import { inject, Injectable } from '@angular/core';
import { ExternalLinkService } from './external-link.service';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import {
    aktyRoute,
    formularzeDocumentoRoute,
    grafikiRoute,
    listyKontrolneRoute,
    orzeczeniaRoute,
    pismaUrzedoweRoute,
    proceduryRoute,
    publikacjeRoute,
    pytaniaOdpowiedziRoute, szkoleniaRoute,
    tezyOrzeczenRoute,
    tezyPublikacjiRoute,
    uzasadnieniaOrzeczenRoute, wazneTerminyRoute,
    wzoryRoute
} from '../app.routing.consts';
import { ObiektType } from '../ladon-api-enums/WK.Ladon.Cms.Common.Model.Enum.ObiektType';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { routeCommands } from '../app.routing.helper';

@Injectable({
    providedIn: 'root'
})
export class ExternalLinkGuard {

    constructor(private readonly router: Router,
                private readonly externalLinkService: ExternalLinkService) {
    }

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.externalLinkService.getListForNro(+route.params.nro).pipe(
            map(result => {
                const routeTemp = ExternalLinkGuard.routeForObiektType(result.obiektType);
                let params = {obiektId: result.obiektId};
                if (routeTemp[ 1 ]) {
                    params = {...params, ...{metadataId: routeTemp[ 1 ]}};
                }
                this.router.navigate(routeCommands(routeTemp[ 0 ], params));
                return false;
            }),
            catchError(error => of(true)));
    }

    private static routeForObiektType(obiektType: ObiektType): [string, string] {
        switch (obiektType) {
            case ObiektType.Akt:
                return [aktyRoute, null];
            case ObiektType.PismoUrzedowe:
                return [pismaUrzedoweRoute, null];
            case ObiektType.ListaKontrolna:
                return [listyKontrolneRoute, null];
            case ObiektType.Orzeczenie:
                return [orzeczeniaRoute, null];
            case ObiektType.Orzeczenie_Teza:
                return [tezyOrzeczenRoute, null];
            case ObiektType.Orzeczenie_Uzasadnienie:
                return [uzasadnieniaOrzeczenRoute, null];
            case ObiektType.FormularzDocumento:
                return [formularzeDocumentoRoute, null];
            case ObiektType.PytanieOdpowiedz:
                return [pytaniaOdpowiedziRoute, null];
            case ObiektType.Publikacja:
                return [publikacjeRoute, null];
            case ObiektType.Publikacja_Teza:
                return [tezyPublikacjiRoute, null];
            case ObiektType.Wzor:
                return [wzoryRoute, null];
            case ObiektType.Grafika:
                return [grafikiRoute, null];
            case ObiektType.Procedura:
                return [proceduryRoute, null];
            case ObiektType.KontenerProcedury:
                return [proceduryRoute, 'Procedura_NrKontenera'];
            case ObiektType.Szkolenie:
                return [szkoleniaRoute, null];
            case ObiektType.WaznyTermin:
                return [wazneTerminyRoute, null];
            default:
                throw new Error('Unknown value');
        }
    }
}

export const ExternalLinkGuardCanActivate: CanActivateFn =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        return inject(ExternalLinkGuard).canActivate(route);
    };
